// hvacAssessmentData.js

export const allSets = {
  1: [
    { id: "q1", label: "Energy monitoring and tracking is implemented", pillar: "Energy Efficiency" },
    { id: "q2", label: "Regular HVAC maintenance schedules are followed", pillar: "Maintenance" },
    { id: "q3", label: "Indoor air quality is monitored regularly", pillar: "IAQ" },
    { id: "q4", label: "Sustainability policies are documented", pillar: "Policies" },
    { id: "q5", label: "Automation is used for HVAC optimization", pillar: "Automation" },
  ],
  2: [
    { id: "q1", label: "Use of energy-efficient equipment", pillar: "Energy Efficiency" },
    { id: "q2", label: "Preventive maintenance programs exist", pillar: "Maintenance" },
    { id: "q3", label: "Air filters are changed on schedule", pillar: "IAQ" },
    { id: "q4", label: "Environmental compliance is ensured", pillar: "Policies" },
  ],
  3: [
    { id: "q1", label: "Real-time energy dashboards available", pillar: "Energy Efficiency" },
    { id: "q2", label: "Predictive maintenance systems in place", pillar: "Maintenance" },
    { id: "q3", label: "Air quality alerts and alarms implemented", pillar: "IAQ" },
    { id: "q4", label: "Staff trained in sustainability practices", pillar: "Policies" },
    { id: "q5", label: "Automated demand control ventilation used", pillar: "Automation" },
  ],
  4: [
    { id: "q1", label: "HVAC optimization based on occupancy", pillar: "Automation" },
    { id: "q2", label: "Energy audits conducted periodically", pillar: "Energy Efficiency" },
    { id: "q3", label: "Maintenance logs and reports automated", pillar: "Maintenance" },
    { id: "q4", label: "Green certifications pursued", pillar: "Policies" },
  ],
  5: [
    { id: "q1", label: "AI predicts and reduces energy wastage", pillar: "Energy Efficiency" },
    { id: "q2", label: "Predictive maintenance fully integrated", pillar: "Maintenance" },
    { id: "q3", label: "Real-time IAQ optimization", pillar: "IAQ" },
    { id: "q4", label: "Organization leads in sustainability", pillar: "Policies" },
    { id: "q5", label: "Full automation & optimization active", pillar: "Automation" },
  ],
};

export const hvacExtras = [
  { id: "e1", label: "HVAC systems use variable speed drives", pillar: "Energy Efficiency" },
  { id: "e2", label: "Cooling towers efficiency monitored", pillar: "Energy Efficiency" },
  { id: "e3", label: "Regular coil cleaning and checks performed", pillar: "Maintenance" },
  { id: "e4", label: "Advanced filtration for IAQ", pillar: "IAQ" },
  { id: "e5", label: "AI-based predictive scheduling implemented", pillar: "Automation" },
];
